<template>
	<div class="marker-detail__slider marker-detail__slider--activ">
		<div class="swiper" ref="swiper">
			<div class="swiper-wrapper">
				<div class="swiper-slide" v-for="image in images">
					<img :src="image" alt="" />
				</div>
			</div>
			<div class="swiper-pagination"></div>
			<div class="btn-next"></div>
			<div class="btn-prev"></div>
		</div>

		<div class="lds-ring">
			<div></div>
			<div></div>
			<div></div>
			<div></div>
		</div>
	</div>
</template>

<script>
import Swiper, { Pagination, Autoplay, Navigation } from 'swiper';
import 'swiper/css/bundle';

export default {
	name: 'MarkerDetailAnalyseSlider',
	props: ['images'],
	mounted() {
		this.slider = new Swiper('.swiper', {
			modules: [Pagination, Autoplay, Navigation],
			loop: true,
			autoplay: {
				delay: 8000,
			},
			pagination: {
				el: '.swiper-pagination',
			},
			navigation: {
				nextEl: '.btn-next',
				prevEl: '.btn-prev',
			},
		});
	},
    beforeUnmount() {
        this.slider.destroy();
    },
	data() {
        return {
            slider: null,
        }
    },
};
</script>
